import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sub_item = _resolveComponent("sub-item", true)!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chils, (val) => {
      return (_openBlock(), _createElementBlock(_Fragment, null, [
        (val.children && val.children.length > 0)
          ? (_openBlock(), _createBlock(_component_el_sub_menu, {
              index: val.path,
              key: val.path
            }, {
              title: _withCtx(() => [
                _createElementVNode("i", {
                  class: _normalizeClass(val.meta.icon)
                }, null, 2),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t(val.meta.title)), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_sub_item, {
                  chil: val.children
                }, null, 8, ["chil"])
              ]),
              _: 2
            }, 1032, ["index"]))
          : (_openBlock(), _createBlock(_component_el_menu_item, {
              index: val.path,
              key: val.path
            }, {
              default: _withCtx(() => [
                (!val.meta.isLink || (val.meta.isLink && val.meta.isIframe))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(val.meta.icon ? val.meta.icon : '')
                      }, null, 2),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t(val.meta.title)), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      href: val.meta.isLink,
                      target: "_blank",
                      rel: "opener"
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(val.meta.icon ? val.meta.icon : '')
                      }, null, 2),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t(val.meta.title)), 1)
                    ], 8, _hoisted_1))
              ]),
              _: 2
            }, 1032, ["index"]))
      ], 64))
    }), 256))
  ]))
}